import IWaveScore from './IWaveScore';

const IWaveEvaluationClassNameMap = {
  [IWaveScore.WEAK]: 'text-[#DF3226]',
  [IWaveScore.FAIR]: 'text-[#FF9901]',
  [IWaveScore.GOOD]: 'text-[#2C68DD]',
  [IWaveScore.STRONG]: 'text-[#00A35E]',
};

export default IWaveEvaluationClassNameMap;
